import { PlanType } from '@guud/creative-studio-types';
import { create } from 'zustand';
import { GraphicOrderBy } from './searchStore';

export const DEFAULT_PAGINATION_TAKE = 30;

export interface PaginationQueryParams {
  skip: number;
  take: number;
  name?: string;
  tags?: string[];
  plan: PlanType;
  purposeKeys?: string[];
  resolutionIds?: string[];
  themeKeys?: string[];
  orderBy?: GraphicOrderBy;
}

export interface PaginationState {
  totalPages: number;
  currentPage: number; // normal pagination
  pageParam: number; // infinite query
  queryParams: PaginationQueryParams;
  isDataStale?: boolean;
}

const initialQueryParamsState: PaginationQueryParams = {
  skip: 0,
  take: DEFAULT_PAGINATION_TAKE,
  name: null,
  tags: null,
  plan: 'STARTER',
  purposeKeys: null,
  resolutionIds: null,
  themeKeys: null,
  orderBy: null
};

const initialPaginationState: PaginationState = {
  totalPages: 0,
  currentPage: 1,
  pageParam: 0,
  queryParams: initialQueryParamsState,
  isDataStale: false
};

interface PaginationActions {
  getPagination: () => PaginationState;
  getCurrentPage: () => number;
  getTotalPages: () => number;

  setPagination: (pagination: PaginationState) => void;
  setPaginationCurrentPage: (currentPage: number) => void;
  setPaginationTotalPages: (totalPages: number) => void;

  setIsDataStale: (isDataStale: boolean) => void;

  resetQueryParams: () => void;
  reset: () => void;
}

export const usePaginationStore = create<PaginationState & PaginationActions>(
  (set, get) => ({
    ...initialPaginationState,

    getPagination: () => get(),
    getCurrentPage: () => get().currentPage,
    getPageParam: () => get().pageParam,
    getTotalPages: () => get().totalPages,

    setPagination: (pagination) => {
      set({
        ...pagination
      });
    },

    setPaginationCurrentPage: (currentPage) => {
      set({
        currentPage
      });
    },

    setPaginationTotalPages: (totalPages) => {
      set({
        totalPages
      });
    },

    setIsDataStale: (isDataStale) => {
      set({
        isDataStale
      });
    },

    resetQueryParams: () => {
      set({
        queryParams: initialQueryParamsState
      });
    },

    reset: () => {
      set(initialPaginationState);
    }
  })
);
